<template>
  <div class="calendar">
    <div class="groupInpLine">
      <div class="placeholder-container bigInp_centered"
      :class="{ 'error': startInvalid }">
        <input
          type="text"
          placeholder=" "
          name="start"
          class="mainInp bigMainInp"
          :value="formatStartDate"
          @click="togglePopup(true)"
          readonly />
        <label for="start">{{ startPlaceholder }}</label>
        <div class="error-input-message" v-if="invalid && invalid.start ">
          {{ $t('qic_error_empty_input') }}
        </div>
      </div>

      <div class="placeholder-container bigInp_centered"
      :class="{ 'error': endInvalid }">
        <input
          type="text"
          placeholder=" "
          :value="formatEndDate"
          class="mainInp bigMainInp"
          @click="togglePopup(true)"
          readonly />
        <label for="end">{{ endPlaceholder }}</label>
        <div class="error-input-message" v-if="invalid && invalid.end ">
          {{ $t('qic_error_empty_input') }}
        </div>
      </div>
    </div>
    <Teleport to="body" v-if="showPopup">
      <div class="calendar-mobile">
        <div class="calendar-mobile__header">
          <div class="calendar-mobile__title">{{ $t('inbound_calendar_header') }}</div>
          <div class="close-popup"
            @click="togglePopup(false)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </div>
        </div>
        <CalendarRange
          mobilePopupOn
          :value="range"
          :min-date="minDate"
          :max-date="maxDate"
          :start-placeholder="startPlaceholder"
          :end-placeholder="endPlaceholder"
          :invalid="invalid"
          @input="onInput"/>
          <div class="calendar-mobile__bottom">
          <BaseButton
            symbol="no"
            @click="togglePopup(false)">
            {{ $t('qic_dropdown_save_button') }}
          </BaseButton>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import CalendarRange from './CalendarRange.vue'
import Teleport from 'vue2-teleport'
import { formatDateWithoutTz } from '../../utils/formatDate'
import BaseButton from '../buttons/BaseButton'
export default {
  name: 'CalendarMobileRange',
  components: {
    CalendarRange,
    Teleport,
    BaseButton
  },
  props: {
    value: {},
    minDate: {},
    maxDate: {},
    invalid: {},
    startPlaceholder: { type: String, default: '' },
    endPlaceholder: { type: String, default: '' }
  },
  data () {
    return {
      showPopup: false
    }
  },
  computed: {
    range: {
      get () {
        return this.value
      }
    },
    formatStartDate () {
      return formatDateWithoutTz(this.value.start, this.$i18n.locale)
    },
    formatEndDate () {
      return formatDateWithoutTz(this.value.end, this.$i18n.locale)
    },
    startInvalid () {
      return !!this.invalid?.start || false
    },
    endInvalid () {
      return !!this.invalid?.end || false
    },
    startValid () {
      return !this.startInvalid && this.start
    },
    endValid () {
      return !this.endInvalid && this.end
    }
  },
  methods: {
    togglePopup (value) {
      const body = document.querySelector('body')
      if (value) {
        body.classList.add('overflow-off')
      } else body.classList.remove('overflow-off')
      this.showPopup = value
    },
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>
  .acceptInp.mainInp:hover{
    background-image: url(~../../assets/images/check.svg);
    background-repeat: no-repeat;
  }
  .clearInput-enter-active, .clearInput-leave-active {
    transition: opacity 0.1s;
  }
  .clearInput-enter, .clearInput-leave-to {
    opacity: 0;
  }
  .calendarInp {
    transition: 0s;
  }
</style>
<style lang="scss" scoped>
  .error-input-message {
    color: #ef3030;
    font-size: 12px;
    line-height: 1;
    margin-top: 8px;
  }
</style>
